// extracted by mini-css-extract-plugin
export default {"savingSpinner":"style_savingSpinner__oz-UX"};